module.exports = {
  name: 'CRM TRIE Adventures',
  footerText: 'CRM TRIE Adventures All Rights Reserved 2017',
  logoSrc: 'assets/img/logo.png',
  logoText: 'CRM TRIE Adventures',
  needLogin: true,
  externalUrl: 'https://tours.triehotels.com/',
  slug: 'crmhotel',
  api: 'https://api2.estateprocrm.com/parse-server/crmhotel/',
  appId: 'UFK0LhDfvSuuy9VyymiItepF6FFitduXGQhnCXdo',
  apiKey: 'N8mrsBgXicrrXbbMkmGjHFxxwiQwNMYhWazzQkxh',
  masterKey: '1RjLD815pz2UgsjNxXXhPR7nTjim0XyivW6p43uB',
  color: '#f3b633'
}



// WEBPACK FOOTER //
// ./src/utils/config.js